'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _user = require('../../redux/modules/user');

var _IndieProgramFormValidation = require('../../utils/IndieProgramFormValidation');

var _IndieProgramFormValidation2 = _interopRequireDefault(_IndieProgramFormValidation);

var _emailValidator = require('email-validator');

var _TellUsProgramPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/TellUsProgramPopup');

var _TellUsProgramPopup2 = _interopRequireDefault(_TellUsProgramPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(values) {
  var errors = {};
  var i = 0,
      j = 0;
  for (var key in values) {
    if (values[key] !== true) {
      if (i === j) errors[key] = true;else {
        for (var key1 in values) {
          errors[key1] = false;
        }
      }
      i++;
    }
    j++;
  }

  return errors;
}

var TellUsProgramContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'indie',
  fields: ['comments', 'checkGaming', 'checkBoxFilm', 'checkBoxArchitecture', 'checkBoxAutomotiveTransportation', 'checkEngineeringConstruction', 'checkBoxProductVisualisation', 'checkBoxAdsExperiences', 'checkBoxSimulationCompanies', 'checkBoxAerospaceDefense', 'checkBoxEdTech', 'checkBoxOther', 'select', 'teamSize', 'releaseDate', 'checkBoxFunding', 'checkBoxPublisher'],
  validate: validate
}), _dec2 = (0, _reactRedux.connect)(null, { setWorkInfo: _user.setWorkInfo }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(TellUsProgramContainer, _React$Component);

  function TellUsProgramContainer(props) {
    (0, _classCallCheck3.default)(this, TellUsProgramContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TellUsProgramContainer.__proto__ || (0, _getPrototypeOf2.default)(TellUsProgramContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null,
      workInfo: '',
      other: ''
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    _this.getSelectedWorkInfo = _this.getSelectedWorkInfo.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(TellUsProgramContainer, [{
    key: 'complieMessage',
    value: function complieMessage(values) {
      var array = [];
      var checkGaming = values.checkGaming,
          checkBoxFilm = values.checkBoxFilm,
          checkBoxArchitecture = values.checkBoxArchitecture,
          checkBoxAutomotiveTransportation = values.checkBoxAutomotiveTransportation,
          checkEngineeringConstruction = values.checkEngineeringConstruction,
          checkBoxProductVisualisation = values.checkBoxProductVisualisation,
          checkBoxAdsExperiences = values.checkBoxAdsExperiences,
          checkBoxSimulationCompanies = values.checkBoxSimulationCompanies,
          checkBoxAerospaceDefense = values.checkBoxAerospaceDefense,
          checkBoxEdTech = values.checkBoxEdTech,
          checkBoxOther = values.checkBoxOther,
          checkBoxPublisher = values.checkBoxPublisher,
          checkBoxFunding = values.checkBoxFunding;

      if (checkGaming) {
        array.push('Gaming');
      }
      if (checkBoxFilm) {
        array.push('Film');
      }if (checkBoxAutomotiveTransportation) {
        array.push('Automotive & Transportation');
      }if (checkBoxArchitecture) {
        array.push('Architecture');
      }if (checkEngineeringConstruction) {
        array.push('Engineering & Construction');
      }if (checkBoxAdsExperiences) {
        array.push('Ads and experiences');
      }if (checkBoxEdTech) {
        array.push('EdTech');
      }if (checkBoxProductVisualisation) {
        array.push('Product Visualisation');
      }if (checkBoxSimulationCompanies) {
        array.push('Simulation Companies');
      }if (checkBoxAerospaceDefense) {
        array.push('Aerospace & Defense');
      }
      if (checkBoxOther) {
        array.push(this.state.other);
      }

      return {
        "workInfo": this.state.workInfo,
        "industry": array
      };
    }
  }, {
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var message = this.complieMessage(values);

      return this.props.setWorkInfo(message).then(function () {
        _this2.setState({
          message: 'Thank you for your work info!'
        });
      }, function (reason) {
        _this2.setState({
          error: reason.msg ? reason.msg : reason.message
        });
      });
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'getSelectedWorkInfo',
    value: function getSelectedWorkInfo(workInfo, other) {
      this.setState({
        workInfo: workInfo,
        other: other
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          checkGaming = _props$fields.checkGaming,
          checkBoxFilm = _props$fields.checkBoxFilm,
          checkBoxArchitecture = _props$fields.checkBoxArchitecture,
          checkBoxAutomotiveTransportation = _props$fields.checkBoxAutomotiveTransportation,
          checkEngineeringConstruction = _props$fields.checkEngineeringConstruction,
          checkBoxProductVisualisation = _props$fields.checkBoxProductVisualisation,
          checkBoxAdsExperiences = _props$fields.checkBoxAdsExperiences,
          checkBoxSimulationCompanies = _props$fields.checkBoxSimulationCompanies,
          checkBoxAerospaceDefense = _props$fields.checkBoxAerospaceDefense,
          checkBoxEdTech = _props$fields.checkBoxEdTech,
          checkBoxOther = _props$fields.checkBoxOther,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          title = _props.title,
          description = _props.description,
          tag = _props.tag,
          childReference = _props.childReference;
      //console.log(this.props);

      return _react2.default.createElement(_TellUsProgramPopup2.default, (0, _extends3.default)({
        icon: '/quixel_logo.png',
        subDescription: 'We want to get to know you a little better. Let us know what you do. This helps us make our service better.',
        getSelectedWorkInfo: this.getSelectedWorkInfo
      }, this.props.fields, {
        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),
        title: title,
        description: description,
        tag: tag,
        onChildRef: childReference
      }));
    }
  }]);
  return TellUsProgramContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = TellUsProgramContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TellUsProgramContainer/TellUsProgramContainer.jsx
// module id = 2670
// module chunks = 0